exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.take-card {\n  display: flex;\n  align-items: stretch;\n  margin-top: 0.3rem;\n  border: 1px solid #ccc;\n  min-height: 2.1rem;\n}\n.take-card .left {\n  flex: 1;\n  text-align: center;\n  color: #f13b3a;\n  border-right: 2px #ccc dashed;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.take-card .left .amount {\n  font-size: 0.6rem;\n  font-weight: bold;\n}\n.take-card .left .num {\n  margin-top: 0.2rem;\n  font-size: 0.35rem;\n}\n.take-card .right {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 0.15rem 0.2rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8308e664","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/TakeCardItem.vue
// module id = 91KU
// module chunks = 15